import { gql } from 'apollo-angular';

export class blogNewsQueries {
	public static blogNewsAll = gql`
		query blogNewsAll {
			blogNewsAll
		}
	`;
} 